import React from 'react';
import PropTypes from 'prop-types';
import useUtils from 'app/hooks/useUtils';
import { SeatsDetailsItem, SeatsDetailsName } from '../styles';

const propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired
};

const ModalLegendContent = ({ data }) => {
  const { buildContentStaticUrl } = useUtils();

  return (
    <ul>
      {data.map(item => {
        return (
          <SeatsDetailsItem key={item.displayName}>
            <div className="l-seats-details__icon">
              <img src={buildContentStaticUrl(item.image)} className="l-legend__icon" alt="" />
              <SeatsDetailsName categoryColor={item.categoryColor}>
                {item.displayName}
              </SeatsDetailsName>
            </div>

            <h5 className="l-seats-details__title">{item.title}</h5>
            <p className="l-seats-details__description">{item.description}</p>
          </SeatsDetailsItem>
        );
      })}
    </ul>
  );
};

ModalLegendContent.propTypes = propTypes;
export default ModalLegendContent;
